// src/components/private/highgarden/OfferOptions.js
// Component to enable a user to select an option to see the offers

import React from 'react';
import AllOffers from './AllOffers';
import ProductOffers from './ProductOffers';
import OptionSelector from '../../common_components/OptionSelector';
import InactiveOffers from './InactiveOffers';
import CustomOffers from './CustomOffers';

const options = [
    {
        icon: "bi bi-box-seam",
        label: "Product Offers",
        value: "productOffers",
        component: ProductOffers
    },
    {
        icon: "bi bi-percent",
        label: "All Offers",
        value: "allOffers",
        component: AllOffers
    },
    {
        icon: "bi bi-file-earmark",
        label: "Custom Offers",
        value: "customOffers",
        component: CustomOffers
    },
    {
        icon: "bi bi-archive",
        label: "Inactive Offers",
        value: "inactiveOffers",
        component: InactiveOffers
    },
];


const OfferOptions = () => {
    return <OptionSelector options={options} initialOption="productOffers" />
};

export default OfferOptions;